import * as React from "react";
import "./Style.css";
import { Box, Modal, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Button from "@mui/material/Button";
import StyledMenuInput from "../../StyledMenu/Index";
import video from "../../../Assets/video.svg";
import videodash from "../../../Assets/play-button.png";
import {
  ARCHIVE_VIDEO,
  COMPETITIVE_INTEL_VIDEO,
  COMPETITIVE_REPORT,
  CRIE_VIDEO,
  FAVORITES_VIDEO,
  ORGANIZATION_DETAIL_CONFIDENCE_SCORE,
  ORGANIZATION_DETAIL_TILE_VIEW,
  PERSONALIZED_DASHBOARD_VIDEO,
  PUSH_TO_JOSF_VIDEO,
  REQUEST_UPDATE,
  UNIVERSAL_SEARCH_VIDEO,
} from "../../../Utils/Constants";
import TrainingModal from "../../Training/TrainingModal";
import moment from "moment";
import { getConfidenceScore } from "../../../Utils/Utils";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router-dom";
export default function CompanyProfile({
  dataForInformation,
  handleToPDF,
  setIsDecisionMakerExcel,
  setIsSalesForceTrigger,
  setArchiveRecord,
  setTrackRecord,
  setRequestUpdateRecord,
  disableRequestUpdate,
  setShareRecord,
  value,
  showSalesForce,
  overviewPdfModal,
  handleOrganizationPdf,
  handleShowPdfModal,
  handleClosePdfModal,
  anchorEl,
  setAnchorEl,
  downloadSingleTab,
  downloadMultipleTab,
  setAddToFavorite,
  handleCheckbox,
  disableTracking,
  handleTrackingdata,
}) {
  const open = Boolean(anchorEl);
  const [videoModal, setVideoModal] = React.useState(false);
  const [overviewVideoModal, setOverviewVideoModal] = React.useState(false);
  const [videoLink, setVideoLink] = React.useState("");

  const handleCloseOverview = () => {
    setOverviewVideoModal(false);
  };
  const handleVideoModal = (item) => {
    setOverviewVideoModal(true);
    if (item === 1) {
      setVideoLink(COMPETITIVE_INTEL_VIDEO);
    } else if (item === 2) {
      setVideoLink(ARCHIVE_VIDEO);
    } else if (item === 3) {
      setVideoLink(FAVORITES_VIDEO);
    } else if (item === 4) {
      setVideoLink(PUSH_TO_JOSF_VIDEO);
    } else if (item === 5) {
      setVideoLink(CRIE_VIDEO);
    } else if (item === 6) {
      setVideoLink(ORGANIZATION_DETAIL_TILE_VIEW);
    } else if (item === 7) {
      setVideoLink(ORGANIZATION_DETAIL_CONFIDENCE_SCORE);
    } else if (item === 8) {
      setVideoLink(UNIVERSAL_SEARCH_VIDEO);
    } else if (item === 9) {
      setVideoLink(REQUEST_UPDATE);
    } else if (item === 10) {
      setVideoLink(COMPETITIVE_REPORT);
    }
  };
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuSalesforce = () => {
    setIsSalesForceTrigger(true);
    setAnchorEl(null);
  };
  const handleMenuDownloadExcel = () => {
    setIsDecisionMakerExcel(true);
    setAnchorEl(null);
  };
  const handleAnchoElement = () => {
    setAnchorEl(null);
  };
  const handleMenuArchiveRecord = () => {
    setArchiveRecord(true);
    setAnchorEl(null);
  };
  const handleMenuTrackRecord = () => {
    setTrackRecord(true);
    setAnchorEl(null);
  };
  const handleMenuAddToFavorite = () => {
    setAddToFavorite(true);
    setAnchorEl(null);
  };
  const handleMenuShareRecord = () => {
    setShareRecord(true);
    setAnchorEl(null);
  };
  const handleMenuRequestUpdateRecord = () => {
    setRequestUpdateRecord(true);
    setAnchorEl(null);
  };
  const handleToPDFClick = () => {
    handleToPDF();
    setAnchorEl(null);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };
  const [isTabPortrait, setIsTabPortrait] = React.useState(false);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)",
    );

    const handler = (e) => {
      setIsTabPortrait(e.matches); // true if media query matches
    };

    // Initial check
    handler(mediaQuery);

    mediaQuery.addEventListener("change", handler);

    return () => {
      mediaQuery.removeEventListener("change", handler);
    };
  }, []);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const navigate = useNavigate();
  return (
    <>
      <div
        className={
          isTabPortrait
            ? "Leades-filter-drop-down-button-main-container-org-res do_not_print"
            : "Leades-filter-drop-down-button-main-container-org do_not_print"
        }
      >
        <div className="org-heading-dropdowns">
          {!isMobile
            ? window?.location.pathname.includes("companyprofilescreen") && (
                <div>
                  <h3>Organization Details</h3>

                  {/* <div className="data-sync-c-rate">
        <div className="datasync-line-c-score">
          <span className="datasync-line">Data Sync: </span>
          <span className="datasync-line-data">
            {dataForInformation?.updated_at
              ? moment(dataForInformation.updated_at).format("MM.DD.YY")
              : "No update information available"}
          </span>
        </div>

        <div className="datasync-line-c-score">
          <span className="datasync-line">Data Confidence Score:</span>
          <span className="datasync-line-data">
            {dataForInformation?.confidence_score
              ? `${dataForInformation.confidence_score * 10}%`
              : "No update information available"}
          </span>
        </div>
      </div> */}
                </div>
              )
            : window?.location.pathname.includes("companyprofilescreen") && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    gap: "40px",
                  }}
                >
                  <div></div>
                  <h3
                    style={{
                      fontFamily: "Inter",
                      fontWeight: "700",
                      fontStyle: "Bold",
                      fontSize: "16px",
                      textAlign: "center",
                    }}
                  >
                    Organization Details
                  </h3>
                  <p>
                    <ClearIcon onClick={() => navigate("/aileads")} />
                  </p>
                </div>
              )}
          <div className="video-space-org-details">
            <div
              className="video_container"
              onClick={() => setVideoModal(!videoModal)}
            >
              <img src={video} alt="video" className="videoIcon" />
              {videoModal && (
                <div className="bell-icon-box-video">
                  <div
                    className="bellicons-notification-container video_drop_hover"
                    onClick={() => handleVideoModal(2)}
                  >
                    <div className="bell-icon-outer-video">
                      {/* <div className="bell-icon-container-inner"> */}
                      <img
                        src={videodash}
                        alt="logo"
                        className="video_img_drop"
                      />
                      {/* </div> */}
                      <div className="bellicon-text">
                        <p className="bellicon-p-search">Archive</p>
                      </div>
                    </div>
                    <div className="bellicon-separator"></div>
                  </div>
                  <div
                    className="bellicons-notification-container video_drop_hover"
                    onClick={() => handleVideoModal(1)}
                  >
                    <div className="bell-icon-outer-video">
                      {/* <div className="bell-icon-container-inner"> */}
                      <img
                        src={videodash}
                        alt="logo"
                        className="video_img_drop"
                      />
                      {/* </div> */}
                      <div className="bellicon-text">
                        <p className="bellicon-p-search">Competitive Intel</p>
                      </div>
                    </div>
                    <div className="bellicon-separator"></div>
                  </div>
                  <div
                    className="bellicons-notification-container video_drop_hover"
                    onClick={() => handleVideoModal(5)}
                  >
                    <div className="bell-icon-outer-video">
                      {/* <div className="bell-icon-container-inner"> */}
                      <img
                        src={videodash}
                        alt="logo"
                        className="video_img_drop"
                      />
                      {/* </div> */}
                      <div className="bellicon-text">
                        <p className="bellicon-p-search">CRIE</p>
                      </div>
                    </div>
                    <div className="bellicon-separator"></div>
                  </div>

                  <div
                    className="bellicons-notification-container video_drop_hover"
                    onClick={() => handleVideoModal(7)}
                  >
                    <div className="bell-icon-outer-video">
                      {/* <div className="bell-icon-container-inner"> */}
                      <img
                        src={videodash}
                        alt="logo"
                        className="video_img_drop"
                      />
                      {/* </div> */}
                      <div className="bellicon-text">
                        <p className="bellicon-p-search">
                          Data Confidence Score
                        </p>
                      </div>
                    </div>
                    <div className="bellicon-separator"></div>
                  </div>

                  <div
                    className="bellicons-notification-container video_drop_hover"
                    onClick={() => handleVideoModal(3)}
                  >
                    <div className="bell-icon-outer-video">
                      {/* <div className="bell-icon-container-inner"> */}
                      <img
                        src={videodash}
                        alt="logo"
                        className="video_img_drop"
                      />
                      {/* </div> */}
                      <div className="bellicon-text">
                        <p className="bellicon-p-search">Favorites</p>
                      </div>
                    </div>
                    <div className="bellicon-separator"></div>
                  </div>

                  <div
                    className="bellicons-notification-container video_drop_hover"
                    onClick={() => handleVideoModal(10)}
                  >
                    <div className="bell-icon-outer-video">
                      {/* <div className="bell-icon-container-inner"> */}
                      <img
                        src={videodash}
                        alt="logo"
                        className="video_img_drop"
                      />
                      {/* </div> */}
                      <div className="bellicon-text">
                        <p className="bellicon-p-search">
                          JOI Competitive Intel PDF Reports
                        </p>
                      </div>
                    </div>
                    <div className="bellicon-separator"></div>
                  </div>

                  <div
                    className="bellicons-notification-container video_drop_hover"
                    onClick={() => handleVideoModal(4)}
                  >
                    <div className="bell-icon-outer-video">
                      {/* <div className="bell-icon-container-inner"> */}
                      <img
                        src={videodash}
                        alt="logo"
                        className="video_img_drop"
                      />
                      {/* </div> */}
                      <div className="bellicon-text">
                        <p className="bellicon-p-search">Push to JOSF</p>
                      </div>
                    </div>
                    <div className="bellicon-separator"></div>
                  </div>
                  {/* <div className="bellicons-notification-container video_drop_hover" onClick={() => handleVideoModal(6)}>
                  <div className="bell-icon-outer-video">
                    <img src={videodash} alt="logo" className="video_img_drop" />
                    <div className="bellicon-text">
                      <p className="bellicon-p-search">Employee Tile View</p>
                    </div>
                  </div>
                  <div className="bellicon-separator"></div>
                </div> */}

                  <div
                    className="bellicons-notification-container video_drop_hover"
                    onClick={() => handleVideoModal(9)}
                  >
                    <div className="bell-icon-outer-video">
                      {/* <div className="bell-icon-container-inner"> */}
                      <img
                        src={videodash}
                        alt="logo"
                        className="video_img_drop"
                      />
                      {/* </div> */}
                      <div className="bellicon-text">
                        <p className="bellicon-p-search">Request Update</p>
                      </div>
                    </div>
                    <div className="bellicon-separator"></div>
                  </div>
                  <div
                    className="bellicons-notification-container video_drop_hover"
                    onClick={() => handleVideoModal(8)}
                  >
                    <div className="bell-icon-outer-video">
                      {/* <div className="bell-icon-container-inner"> */}
                      <img
                        src={videodash}
                        alt="logo"
                        className="video_img_drop"
                      />
                      {/* </div> */}
                      <div className="bellicon-text">
                        <p className="bellicon-p-search">Universal Search</p>
                      </div>
                    </div>
                    <div className="bellicon-separator"></div>
                  </div>
                </div>
              )}
            </div>
            <div className="Leades-filter-inner-container">
              <Button
                style={{ textTransform: "none" }}
                id="action-button"
                aria-controls={open ? "action-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={handleMenuClick}
                endIcon={<KeyboardArrowDownIcon />}
              >
                Action
              </Button>
              <StyledMenuInput
                disableTracking={disableTracking}
                handleShowPdfModal={handleShowPdfModal}
                showSalesForce={showSalesForce}
                handleToPDF={handleToPDFClick}
                anchorEl={anchorEl}
                open={open}
                handleAnchoElement={handleAnchoElement}
                handleMenuSalesforce={handleMenuSalesforce}
                handleMenuDownloadExcel={handleMenuDownloadExcel}
                handleMenuArchiveRecord={handleMenuArchiveRecord}
                handleMenuTrackRecord={handleMenuTrackRecord}
                handleMenuAddToFavorite={handleMenuAddToFavorite}
                handleMenuRequestUpdateRecord={handleMenuRequestUpdateRecord}
                disableRequestUpdate={disableRequestUpdate}
                handleMenuShareRecord={handleMenuShareRecord}
              />
            </div>
            {/* {
            value === 0 ? <div className="Leades-filter-inner-container">
              <Button
                style={{ textTransform: "none" }}
                id="action-button"
                aria-controls={open ? "action-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={handleMenuClick}
                endIcon={<KeyboardArrowDownIcon />}
              >
                Action
              </Button>
              <StyledMenuInput
                showSalesForce={showSalesForce}
                handleToPDF={handleToPDFClick}
                anchorEl={anchorEl}
                open={open}
                handleAnchoElement={handleAnchoElement}
                handleMenuSalesforce={handleMenuSalesforce}
                handleMenuDownloadExcel={handleMenuDownloadExcel}
                handleMenuArchiveRecord={handleMenuArchiveRecord}
                handleMenuTrackRecord={handleMenuTrackRecord}
                handleMenuRequestUpdateRecord={handleMenuRequestUpdateRecord}
                disableRequestUpdate={disableRequestUpdate}
                handleMenuShareRecord={handleMenuShareRecord}
              />
            </div> : null
          } */}
          </div>
        </div>
        {!isMobile ? (
          <div className="data-sync-c-rate-org">
            <div className="datasync-line-c-score">
              <span className="datasync-line">Data Sync: </span>{" "}
              <span className="datasync-line-data">
                {dataForInformation?.updated_at
                  ? moment(dataForInformation.updated_at).format("MM.DD.YY")
                  : "No update information available"}
              </span>{" "}
            </div>
            <div className="datasync-line-c-score">
              <Tooltip
                title={
                  "This score reflects a combination of record completeness, freshness, and data source reliability."
                }
              >
                <span>
                  <span className="datasync-line">Data Confidence Score:</span>
                  <span className="datasync-line-data">
                    {dataForInformation?.confidence_score
                      ? getConfidenceScore(dataForInformation.confidence_score)
                      : "No update information available"}
                  </span>
                </span>
              </Tooltip>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      {/* <Modal
        open={overviewPdfModal}
        onClose={handleClosePdfModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal-joiTraining-videos"
      >
        <Box sx={style} style={{ overflowY: "auto" }}>
          <div className="box-section-relative">
            <div className="de_pad">
              <h3>Download PDF</h3>
              <div className='checkboxes-optns'>
                <div className='inputs-plus-box-dataenrich'>
                  <input
                    type="checkbox"
                    checked={downloadSingleTab}
                    onChange={() => handleCheckbox("one")}
                  />
                  <p>Download Current Tab</p>
                </div>
                <div className='inputs-plus-box-dataenrich'>
                  <input
                    type="checkbox"
                    checked={downloadMultipleTab}
                    onChange={() => handleCheckbox("two")}
                  />
                  <p>Download All Tabs</p>
                </div>
                <div className="btns-companyprofile-cncl-sumbmit">
                  <button onClick={handleClosePdfModal} className="cancel-btn-companyprofile">
                    Cancel
                  </button>
                  <button
                    className="downloadpdf-btn-companyprofile"
                    onClick={() => {
                      if (downloadSingleTab) {
                        handleToPDF();
                      } else if (downloadMultipleTab) {
                        handleOrganizationPdf();
                      }
                    }}
                  >
                    Download Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal> */}

      <TrainingModal
        overviewVideoModal={overviewVideoModal}
        handleCloseOverview={handleCloseOverview}
        videoLink={videoLink}
      />
    </>
  );
}
